// extracted by mini-css-extract-plugin
module.exports = {"root":"CircularText_root__LB9jN","wrapper":"CircularText_wrapper__aIfTh","spin":"CircularText_spin__6DfjF","char":"CircularText_char__beMO0","text":"CircularText_text__ds40z"};